export default __webpack_public_path__ + "static/spinner-e1ed440d25f16bb07e1f116921d0bada.png";